import "core-js/modules/es.function.name.js";

/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { ColorBatch } from 'components';
import { dateFormat, paymentCollectionStatusName, paymentCollectionStatusColorMap } from 'enums';
import { convertToAdditionalCurrency } from 'utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var pendingReportColumns = function pendingReportColumns(windowWidth) {
  return [{
    name: 'ИД',
    render: function render(_ref) {
      var id = _ref.id;
      return ___EmotionJSX("span", {
        "data-value": "payment.id"
      }, id);
    },
    width: '80px'
  }, {
    name: 'Дата',
    value: 'date',
    dateTimeFormat: dateFormat,
    width: '120px'
  }, {
    name: 'Служител',
    render: function render(_ref2) {
      var employee = _ref2.employee;
      return ___EmotionJSX("span", {
        "data-value": "payment.employee"
      }, employee === null || employee === void 0 ? void 0 : employee.name);
    },
    width: '140px'
  }, {
    name: 'Посредник',
    render: function render(_ref3) {
      var franchisee = _ref3.franchisee;
      return ___EmotionJSX("span", {
        "data-value": "payment.franchisee"
      }, franchisee === null || franchisee === void 0 ? void 0 : franchisee.name);
    },
    width: '140px',
    invisibleBelow: 1600
  }, {
    name: 'Кредит №',
    render: function render(_ref4) {
      var credit = _ref4.credit;
      return ___EmotionJSX(Link, {
        "data-value": "payment.credit_number",
        to: "/credits/details/".concat(credit === null || credit === void 0 ? void 0 : credit.id)
      }, credit === null || credit === void 0 ? void 0 : credit.number);
    },
    width: '110px',
    invisibleBelow: 1100
  }, {
    name: 'Сума за отчет',
    render: function render(_ref5) {
      var total_report_amount = _ref5.total_report_amount,
          currency = _ref5.currency;
      return ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.total_report_amount"
      }, total_report_amount, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: total_report_amount,
        fromCurrency: currency
      })));
    },
    width: '110px'
  }, {
    name: 'Статус',
    render: function render(_ref6) {
      var collection_status = _ref6.collection_status;
      return ___EmotionJSX(ColorBatch, {
        type: paymentCollectionStatusColorMap[collection_status]
      }, paymentCollectionStatusName[collection_status]);
    },
    width: '140px'
  }, {
    name: 'Главница',
    render: function render(_ref7) {
      var amount = _ref7.amount,
          currency = _ref7.currency;
      return windowWidth > 3000 ? ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.amount"
      }, amount, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: amount,
        fromCurrency: currency
      }))) : ___EmotionJSX("span", {
        "data-value": "payment.amount"
      }, amount, " ", currency);
    },
    invisibleBelow: 3000
  }, {
    name: 'Лихва',
    render: function render(_ref8) {
      var interest = _ref8.interest,
          currency = _ref8.currency;
      return windowWidth > 3000 ? ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.interest"
      }, interest, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: interest,
        fromCurrency: currency
      }))) : ___EmotionJSX("span", {
        "data-value": "payment.interest"
      }, interest, " ", currency);
    },
    invisibleBelow: 3000
  }, {
    name: 'Лих. проср.',
    render: function render(_ref9) {
      var penalty = _ref9.penalty,
          currency = _ref9.currency;
      return windowWidth > 3000 ? ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.penalty"
      }, penalty, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: penalty,
        fromCurrency: currency
      }))) : ___EmotionJSX("span", {
        "data-value": "payment.penalty"
      }, penalty, " ", currency);
    },
    invisibleBelow: 3000
  }, {
    name: 'Такса ДП',
    render: function render(_ref10) {
      var home_visit_fee_amount = _ref10.home_visit_fee_amount,
          currency = _ref10.currency;
      return windowWidth > 3000 ? ___EmotionJSX("div", null, ___EmotionJSX("p", {
        "data-value": "payment.home_visit_fee_amount"
      }, home_visit_fee_amount !== null && home_visit_fee_amount !== void 0 ? home_visit_fee_amount : '0.00', " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: home_visit_fee_amount,
        fromCurrency: currency
      }))) : ___EmotionJSX("span", {
        "data-value": "payment.home_visit_fee_amount"
      }, home_visit_fee_amount !== null && home_visit_fee_amount !== void 0 ? home_visit_fee_amount : '0.00', " ", currency);
    },
    invisibleBelow: 3000
  }];
};